import { Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { isEmpty } from 'lodash';
@Component({
  selector: 'ihm-editable-label',
  templateUrl: './ihm-editable-label.component.html',
  styleUrls: ['./ihm-editable-label.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => IhmEditableLabelComponent), multi: true }]
})
export class IhmEditableLabelComponent implements ControlValueAccessor {
  // component variables
  @ViewChild('customEditableLabel') readonly customEditableLabel: ElementRef;

  @Output() readonly customLabelChange: EventEmitter<string> = new EventEmitter<string>();

  @Input() readonly showEditIcon: boolean;
  @Input() readonly disabled: boolean;
  @Input() readonly editIconTooltipMessage: string;

  isEditingCustomLabel = false;
  currentInputValue: string;

  private initialInputValue: string;

  get showIcon(): boolean {
    return this.showEditIcon || this.isEditingCustomLabel;
  }

  public onEditInputClick(): void {
    if (this.disabled) {
      return;
    }

    this.isEditingCustomLabel = true;

    setTimeout(() => {
      this.customEditableLabel.nativeElement.focus();
      this.customEditableLabel.nativeElement.classList.add('input-bottom-border');
    });
  }

  public onEditCustomLabelLostFocus(): void {
    this.isEditingCustomLabel = false;
    this.customEditableLabel.nativeElement.classList.remove('input-bottom-border');

    if (isEmpty(this.currentInputValue.trim())) {
      this.currentInputValue = this.initialInputValue;
    }

    if (this.initialInputValue !== this.currentInputValue) {
      this.propagateChange(this.currentInputValue);
      this.customLabelChange.emit(this.currentInputValue);
      this.initialInputValue = this.currentInputValue;
    }
  }

  // ControlValueAccessor methods
  writeValue(currentValue: string): void {
    this.currentInputValue = currentValue;
    this.initialInputValue = currentValue;
  }

  propagateChange = (value: string) => {};

  registerOnChange(fn): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn): void {}
}
